import * as $account from './_account'
import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $resources from './_resources'


export interface IInitOptions {
    pageName  : string;
    pagePrefix: string;
    guid      : string;
    resetGuid : string;
}

export function init(options:IInitOptions) : void {
    var btn = $("#" + options.pagePrefix + "-btn");
    var pw1 = $("#" + options.pagePrefix + "-password1");
    var pw2 = $("#" + options.pagePrefix + "-password2");
    var ca = $("#" + options.pagePrefix + "-captcha");

    pw1.focus();

    pw1.bind("keyup", function (e) {
        var code = e.keyCode || e.which;
        if (code == 13) { btn.trigger("click"); }
    });

    pw2.bind("keyup", function (e) {
        var code = e.keyCode || e.which;
        if (code == 13) { btn.trigger("click"); }
    });

    ca.bind("keyup", function (e) {
        var code = e.keyCode || e.which;
        if (code == 13) { btn.trigger("click"); }
    });

    btn.click(function () {
        $msg.hide();

        $ajax.post({
            loadingText: "Byter lösenord...",
            url: $resources.url.account.changePasswordExternal,
            data: {
                guid: options.guid,
                resetGuid: options.resetGuid,
                password1: pw1.val(),
                password2: pw2.val(),
                captcha: ca.val()
            },
            success: function (res) {
                if (res.Ok) {
                    location.href = $resources.url.account.logIn;
                } else {
                    $msg.showError(res.Message);
                }
            }
        });
    });

    $helpers.makeCaptchaReloadable($("#" + options.pagePrefix + "-captcha-image"));
}